import { gql } from '@apollo/client'
import { BlockFragment } from 'app/features/shared/blocks'
import { ViewableBy } from '../utilities/viewable-check'

export const ContentCarouselBlockFragment: BlockFragment = {
  name: 'contentCarousel',
  fragment: gql`
    fragment contentCarousel on ContentCarousel {
      id
      blockName
      blockType
      items {
        id
        title
        description
        image {
          id
          url
          alt
        }
      }
      contentCarouselMeta: meta {
        viewableBy
      }
      excludedPlatforms {
        ios
        android
        web
      }
    }
  `,
  partialFragment: `
    ...on ContentCarousel {
      id
      blockName
      blockType
      items {
        id
        title
        description
        image {
          id
          url
          alt
        }
      }
      contentCarouselMeta: meta {
        viewableBy
      }
      excludedPlatforms {
        ios
        android
        web
      }
    }
  `,
}

export const ContentCarouselBlockType = 'contentCarousel'

export interface ContentCarouselBlock {
  blockType: typeof ContentCarouselBlockType
  id: string
  blockName?: string
  imagePriority?: boolean
  items: {
    id: string
    title: string
    description: string
    image: {
      url: string
      alt: string
    }
  }[]
  contentCarouselMeta?: {
    viewableBy: [ViewableBy]
  }
}
